import axiosClient from "@/core/axios";
import { IResponse, RoutesQueryParams } from "@/shared/interfaces";
import { DeliveryRoute, RouteResponse } from "@/shared/interfaces/route";
import { IRouterConfiguration } from "@/shared/interfaces/setting";

const routeApi = {
  getRoutes: (params?: RoutesQueryParams): Promise<IResponse<RouteResponse>> => {
    const url = "/routes";
    return axiosClient.get(url, {
      params,
    });
  },
  getRouteSummary: (id: number): Promise<IResponse<DeliveryRoute>> => {
    const url = `routes/${id}/summary`;
    return axiosClient.get(url);
  },
  getRoute: (id: number): Promise<IResponse<DeliveryRoute>> => {
    const url = `routes/${id}`;
    return axiosClient.get(url);
  },
  refreshRoute: (id: number): Promise<IResponse<DeliveryRoute>> => {
    const url = `routes/${id}/refresh-route`;
    return axiosClient.get(url);
  },
  getLoadingSheetPdf: (id: number): Promise<IResponse<any>> => {
    const url = `routes/generate-loading-sheet/${id}`;
    return axiosClient.get(url);
  },
  getDeliverySummaryPdf: (id: number): Promise<IResponse<any>> => {
    const url = `routes/generate-delivery-summary/${id}`;
    return axiosClient.get(url);
  },
  getDeliveryDocketPdf: (id: number): Promise<IResponse<any>> => {
    const url = `routes/generate-delivery-docket/${id}`;
    return axiosClient.get(url);
  },
  getDeliveryDocketForRouteStopPdf: (id: number): Promise<IResponse<any>> => {
    const url = `routes/generate-delivery-docket-for-route-stop/${id}`;
    return axiosClient.get(url);
  },
  createRoute: (data: { routeConfig: IRouterConfiguration }): Promise<IResponse<any>> => {
    const url = "/routes";
    return axiosClient.post(url, data);
  },
  changeSequence: ({ id, payload }: { id: number; payload: DeliveryRoute }): Promise<IResponse<any>> => {
    const url = `routes/${id}/change-sequence`;
    return axiosClient.patch(url, payload);
  },
  updateRoute: ({ id, payload }: { id: number; payload: DeliveryRoute }): Promise<IResponse<any>> => {
    const url = `routes/${id}`;
    return axiosClient.patch(url, payload);
  },
  deleteRoute: (id: number) => {
    const url = `routes/${id}`;
    return axiosClient.delete(url);
  },
  getRouteVehicles: (id: number) => {
    const url = `vehicles/route/${id}`;
    return axiosClient.get(url);
  },
  recalculateRoute: (id: number) => {
    const url = `/routes/${id}/recalculate-route`;
    return axiosClient.patch(url);
  },
  removeRouteFromTrackPOD: (id: number) => {
    const url = `/routes/${id}/remove-from-pod`;
    return axiosClient.get(url);
  },
  sendPlanEmail: (payload: { to: string; routeName: string; csvContent: string }): Promise<IResponse<any>> => {
    const url = "/routes/send-plan-email";
    return axiosClient.post(url, payload);
  },
  getPlanTemplate: (routeConfigId: number): Promise<IResponse<{ routeConfigId: number; customers: any[] }>> => {
    const url = `/routes/plan-template/${routeConfigId}`;
    return axiosClient.get(url);
  },
};

export default routeApi;
